import { render, staticRenderFns } from "./QuestionsSelector.vue?vue&type=template&id=0b7b5bee&scoped=true&"
import script from "./QuestionsSelector.vue?vue&type=script&lang=js&"
export * from "./QuestionsSelector.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsSelector.vue?vue&type=style&index=0&id=0b7b5bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b5bee",
  null
  
)

export default component.exports